export class User {
  constructor(
    readonly id: string,
    readonly isManager: boolean,
  ) {}
}
